var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79246 7.30754C8.38241 6.89749 7.71759 6.89749 7.30754 7.30754C6.89749 7.71759 6.89749 8.38241 7.30754 8.79246L12.5151 14L7.30754 19.2075C6.89749 19.6176 6.89749 20.2824 7.30754 20.6925C7.71759 21.1025 8.38241 21.1025 8.79246 20.6925L14 15.4849L19.2075 20.6925C19.6176 21.1025 20.2824 21.1025 20.6925 20.6925C21.1025 20.2824 21.1025 19.6176 20.6925 19.2075L15.4849 14L20.6925 8.79246C21.1025 8.38241 21.1025 7.71759 20.6925 7.30754C20.2824 6.89749 19.6176 6.89749 19.2075 7.30754L14 12.5151L8.79246 7.30754Z",
    fill: "#00AC6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.1b79b30f9c8e1cef1ec2209fa8516cd7.svg";
export { ForwardRef as ReactComponent };